module.exports = __webpack_public_path__ + "static/img/2.f9fdc03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/cha/2.png
// module id = cczn
// module chunks = 1